import React from 'react';

import { BuilderBlocks, Image } from '@builder.io/react';
import PropTypes from 'prop-types';
import {
  ReactCompareSlider,
  ReactCompareSliderHandle,
} from 'react-compare-slider';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

const Container = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  background-color: ${({ backgroundColor }) => backgroundColor};
  height: 100%;

  ${mobile`
    flex-direction: column;
  `}
`;

const Slider = styled(ReactCompareSlider)`
  display: flex;
  justify-content: center;
  line-height: 0;
  width: 100%;
  height: 100%;
  overflow: visible !important;

  ${mobile`
    overflow: hidden !important;
  `}

  div {
    width: 100%;
    justify-content: center;
    display: flex;
  }

  img {
    height: 100%;
  }
`;

const TextSection = styled.div`
  margin: auto;
  flex-basis: 100%;
  text-align: center;

  ${mobile`
    flex-basis: unset;
  `}
`;

const Img = styled(Image)`
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const BuilderImageComparisonSlider = ({
  builderBlock,
  leftImage,
  rightImage,
  sliderPosition,
  backgroundColor,
}) => {
  const direction = sliderPosition === 'right' ? 'row-reverse' : 'row';

  return (
    <Container
      direction={direction}
      backgroundColor={backgroundColor}
      data-builder-component-type="image_comparison_slider"
    >
      <Slider
        handle={
          <ReactCompareSliderHandle
            buttonStyle={{
              backgroundColor: '#ccc',
              border: 0,
              backdropFilter: 'none',
              WebkitBackdropFilter: 'none',
              boxShadow: 'none',
              overflow: 'visible',
            }}
            linesStyle={{ opacity: 1, boxShadow: '#000 0px 0px 7px' }}
          />
        }
        itemOne={
          <Img src={leftImage} backgroundColor={backgroundColor} alt="" />
        }
        itemTwo={
          <Img src={rightImage} backgroundColor={backgroundColor} alt="" />
        }
      />
      {builderBlock?.children?.length && (
        <TextSection>
          <BuilderBlocks
            parentElementId={builderBlock.id}
            dataPath="component.children"
            blocks={builderBlock.children}
          />
        </TextSection>
      )}
    </Container>
  );
};

BuilderImageComparisonSlider.propTypes = {
  backgroundColor: PropTypes.string,
  builderBlock: PropTypes.object,
  leftImage: PropTypes.string,
  rightImage: PropTypes.string,
  sliderPosition: PropTypes.string,
};

export default BuilderImageComparisonSlider;
